import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import SelectYear from './SelectYear'
import ProflieLoad from '../../Components/Commons/ProflieLoad'

class MyPageForm extends Component {
  render () {
    const onSubmit = this.props.onSubmit
    const onChange = this.props.onChange
    const user = this.props.user
    const authSend = this.props.authSend
    const authCheck = this.props.authCheck
    const originPhoneNumber = this.props.originPhoneNumber
    const handleProfile = this.props.handleProfile

    // 비번 길이 확인
    let passwordMsg = ''
    let passwordLength = false

    if (user.password !== '') {
      if (user.password.length < 8 || user.password.length > 15) {
        passwordMsg = '비밀번호는 8~15자리를 사용해야 합니다.'
        passwordLength = false
      } else {
        passwordMsg = '사용 가능한 비밀번호입니다.'
        passwordLength = true
      }
    }

    // 비번 일치 확인
    let passwordConfirmMsg = ''
    let passwordConfirm = false

    if (user.password !== '' && user.passwordConfirm !== '') {
      if (user.password !== user.passwordConfirm) {
        passwordConfirmMsg = '비밀번호가 일치하지 않습니다.'
        passwordConfirm = false
      } else {
        passwordConfirmMsg = '비밀번호가 일치합니다.'
        passwordConfirm = true
      }
    }


    // 가입 버튼 활성화
    let joinButton = false

    if (user.phoneNumber !== '') {
      if (user.phoneNumber === originPhoneNumber || (user.phoneNumber !== originPhoneNumber)) {
        if (user.password === '' || (user.passwordConfirm === user.password && user.password !== '')) {
          joinButton = true
        }
      }
    }

    return (
      <div>
        <form onSubmit={onSubmit} className="section">
          <h1>마이페이지</h1>
          <div className="select_wrap">

            <ProflieLoad thumbnailUrl={user.thumbnailUrl} url={'user'} handleProfile={handleProfile} label={'프로필 사진을 설정하세요'} />
            <p className="user_name">{user.level} {user.name}<br /><span>{user.email}</span></p>

            <Link to="/withdrawal">
              <div className="withdrawal_btn">
                회원탈퇴
                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12">
                  <path fill="none" fillRule="evenodd" stroke="#A2A7AE" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.2" d="M1.5 1.5l5 4.5-5 4.5"/>
                </svg>
              </div>
            </Link>

            <div className="input_wrap short_input short_input1">
              <label>비밀번호</label>
              <input className="input" type="password" name="password" onChange={onChange} value={user.password} />
              <p className={`check_msg ${passwordLength && 'msg_on'}`}>{passwordMsg}</p>
            </div>

            <div className="input_wrap short_input">
              <label>비밀번호 재확인</label>
              <input className="input" type="password" name="passwordConfirm" onChange={onChange} value={user.passwordConfirm} />
              <p className={`check_msg ${passwordConfirm && 'msg_on'}`}>{passwordConfirmMsg}</p>
            </div>

            <div className="input_wrap phone_wrap">
              <label>휴대폰</label>
              <input className="input" type="number" name="phoneNumber" onChange={onChange} value={user.phoneNumber} placeholder="-없이 숫자만 입력" />
            </div>

            <Link to="/logout">
              <div className="logout_btn">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                  <g fill="none" fillRule="evenodd" stroke="#A2A7AE" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.3">
                    <path d="M7 13H3.429C2.639 13 2 12.463 2 11.8V2.2C2 1.537 2.64 1 3.429 1H7M11 9.5L13 7l-2-2.5M12.6 7H5.227"/>
                  </g>
                </svg>
                로그아웃 하기
              </div>
            </Link>
            <button type="submit" className={`${joinButton && 'joinbtn_on'}`} disabled={joinButton ? false : 'disabled'} >변경하기</button>

          </div>
        </form>
      </div>
    )
  }
}

export default MyPageForm



// WEBPACK FOOTER //
// ./Src/Components/User/MyPageForm.js